

export class RoutePathRouteGroupInput implements IRoutePathRouteGroupInput {
    /** The auto-generated id of the route path master */
    routePathId!: number;

    constructor(data?: IRoutePathRouteGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.routePathId = _data["routePathId"];
        }
    }

    static fromJS(data: any): RoutePathRouteGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new RoutePathRouteGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["routePathId"] = this.routePathId;
        return data; 
    }
}

export interface IRoutePathRouteGroupInput {
    /** The auto-generated id of the route path master */
    routePathId: number;
}

